import React from "react";
import ScrollIntoView from "./scrollIntoView";

const InstructionSteps = () => {



    return (
        <>
            <ScrollIntoView block="start" />
            <div className="custom-instructions__helper">
                <p>We're sorry if the cover doesn't fit as expected, we're happy to take a look.</p>
                <p>  Please follow the instructions below carefully, making sure to take a photo for each step so we can properly review everything correctly.</p>
            </div>
            <div className="custom-instructions">
                <div className="custom-instructions__card">
                    <p className="custom-instructions__title">1. Take a Photo of the Tag</p>
                    <div className="custom-instructions__image">
                        <img src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/White_tag.png?v=1755782994" />
                    </div>
                    <p className="custom-instructions__description">Capture the tag inside your cover and ensure the <strong> SKU number</strong> near the logo is clearly visible.</p>
                </div>
                <div className="custom-instructions__card">
                    <p className="custom-instructions__title">2. Take a Wide-Angle Picture </p>
                    <div className="custom-instructions__image">
                        <img src="https://cdn.shopify.com/s/files/1/0313/1477/2027/files/Wide-angle_photo.png?v=1754577832" />
                    </div>
                    <p className="custom-instructions__description">Take a photo of your cover <strong>not fitting</strong>, ensuring the <strong>entire cover</strong> is visible in the frame.</p>
                </div>
                <div className="custom-instructions__card">
                    <p className="custom-instructions__title">3. Use a Tape Measure</p>
                    <div className="custom-instructions__image">
                        <img src="https://cdn.shopify.com/s/files/1/0313/1477/2027/files/tape_measure.png?v=1754577833" />
                    </div>
                    <p className="custom-instructions__description">Include a tape measure in the photos as a reference to <strong>confirm the dimensions</strong>.</p>
                </div>
            </div>
        </>
    )
}

export default InstructionSteps;